<div class="container">
    <form [formGroup]="formGroup">
        <div class="row sectionTitle" *ngIf="sectionTitle">
            <div class="col-sm-12">
                <b>{{sectionTitle}}</b>
            </div>
        </div>

        <ng-container *ngIf="collapseItem?.needAssignStatus()">
            <div class="row title">
                <div class="col-sm-12">
                    {{'components.editRequest.assignStatus' | translate}}
                    <span class="text-danger" *ngIf="formGroup.get('status')?.errors?.required"> ( {{'components.editRequest.errors.statusIsRequired' | translate}} )</span>
                </div>
            </div>
            <div class="row value">
                <div class="col-sm-12">
                    <select class="wholeWidth" formControlName="status">
            <option value=""></option>
            <option *ngFor="let status of statuses" [value]="status.code">{{status.name}}</option>
            </select>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="collapseItem?.needResponseToClient()">
            <div class="row title">
                <div class="col-sm-12">
                    {{'components.editRequest.responseToClient' | translate}}
                    <span class="text-danger" *ngIf="formGroup.get('reason')?.errors?.required"> ( {{'components.editRequest.errors.reasonIsRequired' | translate}} )</span>
                </div>
            </div>
            <div class="row value">
                <div class="col-sm-12">
                    <select class="wholeWidth" formControlName="reason">
            <option value=""></option>
            <option *ngFor="let comment of comments" [value]="comment.code">{{comment.name}}</option>
            </select>
                </div>
            </div>
        </ng-container>


        <div class="row value d-block" *ngIf="collapseItem?.needAddPhoto()">

            <app-photos-gallery #photosGalleryControl [showCancelSaveButtons]=false [request]="request">
            </app-photos-gallery>
        </div>


        <ng-container *ngIf="collapseItem?.needInternalComment()">
            <div class="row title">
                <div class="col-sm-12">
                    {{'components.editRequest.internalComment' | translate}}
                    <span class="text-danger" *ngIf="formGroup.get('internalComment')?.errors?.required"> ( {{'components.editRequest.errors.internalCommentIsRequired' | translate}} )</span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12"><textarea class="wholeWidth" rows="3" formControlName="internalComment" maxlength="1000"></textarea></div>
            </div>
        </ng-container>


        <ng-container *ngIf="collapseItem?.needAssignAllowableUser()">
            <div class="row title" >
            <div class="col-sm-12"> {{assignAllowableUserText | translate}}
                </div>
            </div>
            <div class="row value">
                <div class="col-sm-12">
                    <select class="wholeWidth contains-glyphicon" formControlName="allowableUser">
                        <option value=""></option>
                        <option *ngFor="let responsible of allowableUsersList" [value]="responsible.userCode">{{responsible.lastName}} {{responsible.firstName}}</option>
                    </select>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="collapseItem?.needAssignAllowableActivity()">
            <div class="row title" >
            <div class="col-sm-12"> {{"components.editRequest.chooseNewActivity" | translate}}
                </div>
            </div>
            <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">Activité</th>
                    <th scope="col">Modèle</th>
                    <th scope="col">Type</th>
                    <th scope="col">Responsable</th>
                    <th scope="col">Unité</th>
                  </tr>
                </thead>
                <tbody>
                  <tr [ngClass]="{'selectedRow': activity === formGroup.controls.allowableActivity.value}" *ngFor="let activity of allowableActivitiesList" (click)="getSelectedActivity(activity)">
                    <td>{{activity.name}}  </td>
                    <td>{{activity.template.name}}</td>
                    <td>{{activity.type}}</td>
                    <td>{{activity.group.name}}</td>
                    <td>{{activity.responsibleUnit.name}}</td>
                  </tr>
                </tbody>
            </table>
        </ng-container>
    </form>
    <hr class="separatorLight" />
    <div class="row value" [class.sectionDisabled]="exitInProgress">
        <div class="col-sm-6">
            <button class="btnRound" type="button" (click)="cancelCollapseItemEdit()">
        <i class="fa fa-times" aria-hidden="true"></i> {{'components.editRequest.cancel' | translate}}
      </button>
        </div>
        <div class="col-sm-6">
            <button class="btnFilled" type="button" [disabled]="formGroup.invalid" (click)="submit()">
        <i class="fa fa-floppy-o" aria-hidden="true"></i> {{'components.editRequest.save' | translate}}
      </button>
        </div>
    </div>
</div>
